

























	import {Component, Prop} from "vue-property-decorator"
	import AbpBase from "@/lib/abpbase"
    import {QueryPatientEduModel,AddPatientEduPlanBatch } from "@/api/pdOutPatient/pdEducation/pdPatientEdu";

	@Component
	export default class AddPlan1 extends AbpBase {
		@Prop() value: boolean
		@Prop() data: any
		temps: any[] = []
		date = new Date()
		model = {
			planDate: new Date(),
		}

			columns = [
			 {
				type: "selection",
				width: 60,
				align: "center",
				fixed: "left",
			},
			{
				title: '模板名称',
				key: 'modelName',
            } ,
			{
				title: '模板说明',
				key: 'modelNote',
			}
		]

		created() {
			this.getData()
		}

		async save() {
			if (!this.temps.length) {
				this.$Message.error("请先维护宣教计划模板！")
				return
			}
			if(!this.selectedTableRow.length){
				this.$Message.error("请选择宣教计划模板！")
				return
			}
			let patientIdList=[]
			if(this.data.AddType=='单独'){
				patientIdList.push(this.data.patientId);
			}else{
				patientIdList=this.data.patientIdList
			}
			let resourceTempIdList = this.selectedTableRow.map((row) => {
				return row.id;
			});
			const data = {
				patientIdList: patientIdList,
				resourceTempIdList:resourceTempIdList,
				...this.model
			}
			data.planDate = this.formatDate(data.planDate)
			let res = await AddPatientEduPlanBatch(data)
			if(res.objects){
				this.$Modal.confirm({
					title: "提示",
					content:res.objects,
				});
			}
			if (res.status === 1) {
				this.$emit('save-success')
				this.$emit('input', false)
				this.$emit('batchclose')
			}
		}

		private async getData() {
			this.getTemps()

		}

		async getTemps() {
			let res = await QueryPatientEduModel({page: 1,
            pageSize: 99999,
            queryString: "",})
			this.temps = res.items
		}

		cancel() {
			this.$emit('input', false)
		}

		visibleChange(value: boolean) {
			if (!value) {
				this.$emit('input', value);
			}
		}

		selectedTableRow: any[] = [];
		tableSelectionChange(selection: any) {
			this.selectedTableRow = selection;
		}
	}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdOutPatient/pdEducation/pdPatientEducationBatch/addPlan.vue